<script>
  import { fly,fade } from 'svelte/transition';

  export let Title = null;
  export let src;
  export let alt;
  export let id = null;
</script>

<style>
	IMG
	{
			border:1px solid #E1E1E1;
			border-radius: 4px;
	}

	SECTION
	{
		margin-bottom:4rem;
	}

</style>


<section class="row" id="{id}"  transition:fade={{ duration:2000 }} >
<div class="seven columns">
{#if Title}
<h5>{Title}</h5>
{/if}
<slot />
</div>
<img class="five columns" src="{src}" alt="{alt}" />
</section>
